/**
 * Registro do service worker + captura do evento beforeinstallprompt.
 *
 * Só roda em produção (localhost trata como fresh reload sempre).
 * O evento beforeinstallprompt é guardado em window.__rafInstallEvent — o
 * componente InstallAppButton consulta esse valor pra decidir mostrar o CTA.
 */
export const registerPwa = () => {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Captura o prompt de instalação nativo (Android/Chrome) — user gesture depois
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__rafInstallEvent = e;
    window.dispatchEvent(new CustomEvent("raf-installable", { detail: true }));
  });

  window.addEventListener("appinstalled", () => {
    window.__rafInstallEvent = null;
    window.dispatchEvent(new CustomEvent("raf-installed"));
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => { /* offline first-time — ignore */ });
  });
};

/** True se rodando dentro de PWA instalado (standalone). */
export const isStandalone = () => {
  if (typeof window === "undefined") return false;
  return window.matchMedia?.("(display-mode: standalone)").matches
    || window.navigator?.standalone === true; // iOS Safari
};
